import { ShareTypes, ShareInterface, SHARE_TYPES } from './share.model';
import { FacebookShare } from './facebook-share';
import { TwitterShare } from './twitter-share';
import { PinterestShare } from './pinterest-share';
import { EmailShare } from './email-share';

export function shareCreator(type: ShareTypes, url: string): ShareInterface {
  switch (type) {
    case SHARE_TYPES.facebook:
      return new FacebookShare(url);
    case SHARE_TYPES.twitter:
      return new TwitterShare(url);
    case SHARE_TYPES.pinterest:
      return new PinterestShare(url);
    case SHARE_TYPES.email:
      return new EmailShare(url);
  }
  throw new Error(`Share platform ${type} not found`);
}
